<template>
  <resource-show-wrapper class="settings-show__wrapper" :title="'Settings'">
    <va-tabs :selected-tab="selectedTab" :items="tabItems" @change="tabChange">
      <template v-slot:[`profile`]>
        <Profile></Profile>
      </template>
      <!-- TODO:  Hide for now, will enable later on -->
      <!-- <template v-slot:[`notifications`]> </template> -->
      <template v-slot:[`workplace_users`]>
        <WorkplaceUsers></WorkplaceUsers>
      </template>
      <template v-slot:[`billing_payments`]>
        <Billing></Billing>
      </template>
      <template v-slot:[`user_view`]>
        <UserView />
      </template>
      <template v-slot:[`application_data`]>
        <ApplicationData />
      </template>
    </va-tabs>
  </resource-show-wrapper>
</template>

<script>
  import ResourceShowWrapper from "@/components/resourceWrappers/ResourceShowWrapper";
  import VaTabs from "@/components/custom/VaTabs";
  import BriefcaseIcon from "@/components/icons/BriefcaseIcon";
  // Tabs
  import Profile from "@/components/tabs/settings/Profile";
  import WorkplaceUsers from "@/components/tabs/settings/WorkplaceUsers";
  import Billing from "@/components/tabs/settings/billing/Billing";
  import UserView from "@/components/tabs/settings/UserView";
  import ApplicationData from "@/components/tabs/settings/ApplicationData";
  import { eventBus } from "@/event-bus";

  export default {
    name: "Settings",
    components: {
      ResourceShowWrapper,
      VaTabs,
      Profile,
      WorkplaceUsers,
      Billing,
      UserView,
      ApplicationData,
    },
    data() {
      return {
        selectedTab: this.$route?.query?.tab || "profile",
      };
    },
    watch: {
      "$route.query.tab"(newTab) {
        this.selectedTab = newTab;
      },
    },
    beforeMount() {
      this.tabItems = [
        {
          title: this.$t("settings.tabs.account"),
          icon: "mdi-account",
          tabName: "profile",
        },
        // {
        //   title: this.$t("settings.tabs.notifications"),
        //   icon: "mdi-bell-cog-outline",
        //   tabName: "notifications",
        // },

        ...(this.$can("view", "settings workplace users")
          ? [
              {
                title: this.$t("settings.tabs.workplace_users"),
                icon: BriefcaseIcon,
                tabName: "workplace_users",
              },
            ]
          : []),

        ...(this.$can("read", "billing and payments information")
          ? [
              {
                title: this.$t("settings.tabs.billing_payments"),
                icon: "mdi-credit-card-outline",
                tabName: "billing_payments",
              },
            ]
          : []),
        ...(this.$can("view", "user view") && !this.$store.state.user.impersonate
          ? [
              {
                title: this.$t("settings.tabs.user_view"),
                icon: "mdi-eye",
                tabName: "user_view",
              },
            ]
          : []),
        ...(this.$can("view", "application data")
          ? [
              {
                title: this.$t("settings.tabs.application_data"),
                icon: "mdi-application-braces-outline",
                tabName: "application_data",
              },
            ]
          : []),
      ];

      //Event watch for end impersonate to show user view tab (watchers don't work with store)
      eventBus.$on("end-impersonate", () => {
        if (
          this.$can("view", "user view") &&
          !this.$store.state.user.impersonate &&
          !this.tabItems.find(item => item.tabName === "user_view")
        ) {
          this.tabItems.push({
            title: this.$t("settings.tabs.user_view"),
            icon: "mdi-eye",
            tabName: "user_view",
          });
        }
      });
    },
    beforeDestroy() {
      eventBus.$off("end-impersonate");
    },
    mounted() {
      if (this.$route.query?.response) {
        const response = this.$route.query.response;
        switch (response) {
          case "billing_method_success":
            this.$admin.toast.success(this.$t("settings.billing.billing_method.add_payment_method_success"));
            break;
          case "billing_method_failed_invalid":
            this.$admin.toast.error(this.$t("settings.billing.billing_method.add_payment_method_failed_invalid"));
            break;
          default:
            this.$admin.toast.error(this.$t("settings.billing.billing_method.add_payment_method_failed_invalid"));
            break;
        }
        const query = { ...this.$route.query };
        delete query.response;

        this.$router.replace({ path: this.$route.path, query: query });
      }
    },
    methods: {
      tabChange(newTab) {
        this.$router.replace({ query: { tab: newTab } });
        this.$store.commit("SET_PREVIOUS_ROUTE", this.$route.fullPath);
      },
    },
  };
</script>

<style lang="scss" scoped>
  // No back button in Settings UI
  .settings-show__wrapper {
    &::v-deep {
      .show__back {
        display: none;
      }
    }
  }
</style>
